import { BellIcon } from 'lucide-react'

import { NoDataCard } from '@/pages/client-portal/ui/cards/no-data-card/no-data-card'
import { ScheduledAlertsCard } from '@/pages/client-portal/ui/cards/scheduled-alerts-card/scheduled-alerts-card'
import { ContentSectionHeader } from '@/pages/client-portal/ui/content-section-header/content-section-header'

import { type ClientPortalCaseAlertItem } from '@/lib/queries/case-dashboard/types'
import { cn } from '@/lib/utils'

export interface OtherCriticalDatesInternalProps {
  scheduledAlertsData?: ClientPortalCaseAlertItem[]
  onClickGoToCaseDetailButton: VoidFunction
}

export const OtherCriticalDatesInternal = ({
  scheduledAlertsData,
  onClickGoToCaseDetailButton,
}: OtherCriticalDatesInternalProps) => {
  const noData = !scheduledAlertsData || scheduledAlertsData.length === 0

  return (
    <div className={cn('mt-[30px]')}>
      <ContentSectionHeader icon={<BellIcon size={24} />} title="Other Critical Dates" />

      {noData && (
        <div className={cn('mt-5')}>
          <NoDataCard
            cardTitle="Please set other critical alert to display important dates to track."
            cardDescription="This message won't be shown to clients"
            buttonLabel="Set other alert"
            onClickButton={onClickGoToCaseDetailButton}
          />
        </div>
      )}

      {!noData && (
        <div className={cn('mt-5')}>
          <div className={cn('lg:max-w-[400px]')}>
            <ScheduledAlertsCard scheduledAlertsData={scheduledAlertsData} />
          </div>
        </div>
      )}
    </div>
  )
}
